import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeReferenciaConsultaRemuneracaoADMRH: [],
    removeCargoConsultaRemuneracaoADMRH: [],
    removeMatriculaConsultaRemuneracaoADMRH: [],
    removeStatusConsultaRemuneracaoADMRH: [],
    setMostraAplicarFiltroConsultaRemuneracaoADMRH: [],
    limpaFiltroConsultaRemuneracaoADMRH: [],
    aplicarFiltroConsultaRemuneracaoADMRH: ['filtro'],
})

const INITIAL_STATE = {
    referencia: '',
    cargo: '',
    matricula: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: '', mostraAplicarFiltro: true }
}

const removeCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: '', mostraAplicarFiltro: true }
}

const removeMatricula = (state = INITIAL_STATE, action) => {
    return { ...state, matricula: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_REFERENCIA_CONSULTA_REMUNERACAO_ADMRH]: removeReferencia,
    [Types.REMOVE_CARGO_CONSULTA_REMUNERACAO_ADMRH]: removeCargo,
    [Types.REMOVE_MATRICULA_CONSULTA_REMUNERACAO_ADMRH]: removeMatricula,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_REMUNERACAO_ADMRH]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_REMUNERACAO_ADMRH]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_REMUNERACAO_ADMRH]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_REMUNERACAO_ADMRH]: aplicarFiltro,
})
